export default "__VITE_ASSET__Cj_q6yhw__"